import { apiSlice } from "../services/apiSlice";

export const duplicateApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDuplicateCriteria: builder.query({
            query: (criteria) => ({
                url: `/duplicate-criteria?moduleCriteria=${criteria}`
            }),
        }),
        saveCriteria: builder.mutation({
            query: (data) => ({
                url: `/duplicate-criteria/`,
                method: 'POST',
                body: {
                    ...data,
                },
            }),
        }),
        getDuplicates: builder.query({
            query: ({ scope, page = 1 }) => ({
                url: `/duplicate-criteria/duplicates?moduleCriteria=${scope}&page=${page}&limit=50`,
            }),
        }),
        ignoreDuplicate: builder.mutation({
            query: (data) => ({
                url: '/duplicate-criteria/ignore/',
                method: 'PUT',
                body: {
                    ...data,
                }
            }),
        }),
    }),
});

export const {
    useGetDuplicateCriteriaQuery,
    useSaveCriteriaMutation,
    useGetDuplicatesQuery,
    useIgnoreDuplicateMutation,
} = duplicateApiSlice;